import type {Material} from "@project/application/engineering/materials";

import {getMaterialQueryOptions} from "@project/application/engineering/materials";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

import {routeMessages} from "../../../../../messages/routes.messages";

import {MaterialPage} from "./-page/material.page";
import {MaterialPending} from "./-page/material.pending";

const materialSearchSchema = z.object({includeDeleted: z.boolean().default(false)});

export const Route = createFileRoute("/_app/engineering/materials/$materialId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  validateSearch: materialSearchSchema,
  loaderDeps: ({search}) => ({includeDeleted: search.includeDeleted}),
  loader: async ({context: {queryClient}, deps, params}) =>
    queryClient.ensureQueryData(getMaterialQueryOptions(params.materialId, deps.includeDeleted)),
  pendingComponent: MaterialPending,
  staticData: {
    meta: {
      getLabel: (_p: Record<string, string>, data?: unknown) =>
        (data as Material | undefined)?.name,
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.materialById.id,
        values: {materialId: p["materialId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {materialId} = Route.useParams();
  const {includeDeleted} = Route.useSearch();

  return <MaterialPage materialId={materialId} includeDeleted={includeDeleted} />;
}
